import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { useFormik } from 'formik';
import moment from 'moment'
import * as Yup from 'yup';
import Select from 'react-select';
import { toast } from 'react-toastify';
import promoService from '../../Services/promoService'
import { retailerService } from '../../Services';
import helperFunction from '../../Function/helperFunction';
import Loader from '../../Components/Loader'
// const reg = /^(?=.*[A-Z])(?=.*[0-9])/

export const AddPromo = () => {
    const [retailerListData, setRetailerListData] = useState([]);
    // const [promoType, setPromoType] = useState('')
    // const [UserType, setUserType] = useState('')
    const [promoCode, setPromoCode] = useState('')
    // const [promoTypeList,] = useState([{ value: 'PERCENTEGE', label: 'Percentage' }, { value: 'AMOUNT', label: 'Amount' }])
    // const [userTypeList,] = useState([
    //     { value: 'USER', label: 'User' },
    //     { value: 'RETAILER', label: 'Retailer' },
    //     { value: 'CORPORATES', label: 'Corporates' },
    //     { value: 'AGENT', label: 'Agent' }
    // ])
    const [loader, setLoader] = useState(false)

    const history = useHistory()
    const formik = useFormik({
        initialValues: {
            promo_type: 'PERCENTEGE',
            // user_type: '',
            // promo_amount: '',
            retailer_id: '',
            customer_discount: '',
            store_discount: '',
            total_discount: '',
            promo_code: '',
            promo_start_date: '',
            promo_end_date: '',
        },
        validationSchema: Yup.object({
            // promo_type: Yup.string().required('Required'),
            // user_type: Yup.string().required('Required'),
            retailer_id: Yup.string().required('Required'),
            promo_code: Yup.string()
               // .matches(reg, 'At least one alphanumeric character required')
                .min(3, 'Must be 3 characters ')
                .max(7, 'Must be 7 characters ')
                .required('Required'),
            // promo_amount: Yup.string().required('Required'),
            total_discount: Yup.string().required('Required'),
            customer_discount: Yup.string().required('Required'),
            store_discount: Yup.string().required('Required'),
            promo_start_date: Yup.string().required('Required'),
            promo_end_date: Yup.string().required('Required'),
        }),
        onSubmit: values => {
            setLoader(true)
            let postData = {
                ...values,
                promo_start_date: helperFunction.convertDate(values.promo_start_date),
               
                promo_end_date: helperFunction.convertEndDate(values.promo_end_date)
            }
            
            promoService.addPromo(postData).then(res => {
                if (res.status) {
                    setLoader(false)
                    history.push('/promo-list')
                } else {
                    setLoader(false)
                    toast.error(res.message)
                }
            })
        },
    });

    useEffect(() => {
        getRetalerItemList();
    }, []);

    const getRetalerItemList = () => {
        retailerService.getRetailer().then((res) => {
            if (res.status) {
                let listArry = [{ value: 'none', label: 'None' }];
                // eslint-disable-next-line
                res.data.map((val) => {
                    listArry.push({
                        value: val,
                        label: val.retailer_name,
                        contact_name: val.contact_name,
                    });
                });
                setRetailerListData(listArry);
            }
        });
    };

    const retailerHandler = (event) => {
        formik.setValues({ ...formik.values, retailer_id: event.value._id })
    }

    // const onSelectPromoType = (e, act) => {

    //     if (act === 'userType') {
    //         // setUserType(e)
    //         formik.setValues({ ...formik.values, user_type: e.value })
    //     } else {
    //         // setPromoType(e)
    //         formik.setValues({ ...formik.values, promo_type: e.value })

    //     }

    // }

    const onChangeEvent = (value) => {
        formik.setValues({ ...formik.values, promo_code: value.toUpperCase() })
        setPromoCode(value.toUpperCase())
        formik.setTouched({ ...formik.touched, promo_code: true })
    }

    return (
        <div className="row">
            <div className="col-lg-6">
                <div className="card">
                    <div className="card-body">
                        <form className="control-form">
                            <div className="row">
                                <div className="mb-3 col-6">
                                    <label className='form-label'>Retailer Name</label>
                                    <Select
                                        options={retailerListData}
                                        className={'' + (formik.touched.retailer_id ? !formik.errors.retailer_id ? ' is-valid' : ' is-invalid' : '')}
                                        name="retailer_id"
                                        onChange={(e) => retailerHandler(e)}
                                    />
                                    {formik.touched.retailer_id && formik.errors.retailer_id ? (
                                        <div className="text-danger">{formik.errors.retailer_id}</div>
                                    ) : null}
                                </div>
                            </div>

                            <div className="row">
                                <div className="mb-3 col-6">
                                    <label className="form-label">Promo Code</label>
                                    <input
                                        type="text"
                                        className={'form-control' + (formik.touched.promo_code ? !formik.errors.promo_code ? ' is-valid' : ' is-invalid' : '')}
                                        onChange={(e) => onChangeEvent(e.target.value)}
                                        value={promoCode}
                                        // {...formik.getFieldProps('promo_code')}
                                        placeholder="Enter promo code"
                                    />
                                    {formik.touched.promo_code && formik.errors.promo_code ? (
                                        <div className="text-danger">{formik.errors.promo_code}</div>
                                    ) : null}
                                </div>
                                {/* <div className="mb-3 col-4">
                                    <label className="form-label">{formik.values.promo_type != 'PERCENTEGE' ? 'Amount' : 'Percentage'}</label>
                                    <input
                                        type="number"
                                        min="0"
                                        className={'form-control' + (formik.touched.promo_amount ? !formik.errors.promo_amount ? ' is-valid' : ' is-invalid' : '')}
                                        {...formik.getFieldProps('promo_amount')}
                                        placeholder={formik.values.promo_type != 'PERCENTEGE' ? 'Enter amount' : 'Enter percentage'}
                                    />
                                    {formik.touched.promo_amount && formik.errors.promo_amount ? (
                                        <div className="text-danger">{formik.errors.promo_amount}</div>
                                    ) : null}
                                </div> */}
                            </div>
                            <div className="row">
                                <div className="mb-3 col-6">
                                    <label className="form-label">Total Discount</label>
                                    <input
                                        type="number"
                                        name='total_discount'
                                        className={'form-control' + (formik.touched.total_discount ? !formik.errors.total_discount ? ' is-valid' : ' is-invalid' : '')}
                                        onChange={(e) => onChangeEvent(e.target.value)}
                                        {...formik.getFieldProps('total_discount')}
                                        placeholder="Enter Total Discount"
                                    />
                                    {formik.touched.total_discount && formik.errors.total_discount ? (
                                        <div className="text-danger">{formik.errors.total_discount}</div>
                                    ) : null}
                                </div>

                            </div>
                            <div className='row'>
                                <div className="mb-3 col-6">
                                    <label className="form-label">Customer Discount</label>
                                    <input
                                        type="number"
                                        min="0"
                                        name='customer_discount'
                                        className={'form-control' + (formik.touched.customer_discount ? !formik.errors.customer_discount ? ' is-valid' : ' is-invalid' : '')}
                                        {...formik.getFieldProps('customer_discount')}
                                        placeholder='Customer discount'
                                    />
                                    {formik.touched.customer_discount && formik.errors.customer_discount ? (
                                        <div className="text-danger">{formik.errors.customer_discount}</div>
                                    ) : null}
                                </div>

                            </div>
                            <div className='row'>
                                <div className="mb-3 col-6">
                                    <label className="form-label">Store Discount</label>
                                    <input
                                        type="number"
                                        min="0"
                                        name='store_discount'
                                        className={'form-control' + (formik.touched.store_discount ? !formik.errors.store_discount ? ' is-valid' : ' is-invalid' : '')}
                                        {...formik.getFieldProps('store_discount')}
                                        placeholder='Store discount'
                                    />
                                    {formik.touched.store_discount && formik.errors.store_discount ? (
                                        <div className="text-danger">{formik.errors.store_discount}</div>
                                    ) : null}
                                </div>
                            </div>
                            <div className="row">
                                <div className="mb-3 col-6">
                                    <label className="form-label">Start Date</label>
                                    <input
                                        type="date"
                                        id="datemax"
                                        className={'form-control' + (formik.touched.promo_start_date ? !formik.errors.promo_start_date ? ' is-valid' : ' is-invalid' : '')}
                                        {...formik.getFieldProps('promo_start_date')}
                                        name="promo_start_date"
                                        min={moment(new Date()).format('YYYY-MM-DD')}
                                        placeholder="Start date"
                                    />
                                    {formik.touched.promo_start_date && formik.errors.promo_start_date ? (
                                        <div className="text-danger">{formik.errors.promo_start_date}</div>
                                    ) : null}
                                </div>

                            </div>
                            <div className='row'>
                                <div className="mb-3 col-6">
                                    <label className="form-label">End Date</label>
                                    <input
                                        type="date"
                                        className={'form-control' + (formik.touched.promo_end_date ? !formik.errors.promo_end_date ? ' is-valid' : ' is-invalid' : '')}
                                        id="datemax"
                                        name="promo_end_date"
                                        min={formik.values.promo_start_date}
                                        placeholder="End date"
                                        {...formik.getFieldProps('promo_end_date')}
                                    />
                                    {formik.touched.promo_end_date && formik.errors.promo_end_date ? (
                                        <div className="text-danger">{formik.errors.promo_end_date}</div>
                                    ) : null}
                                </div>
                            </div>
                            <div className="mt-3 d-flex justify-content-between">
                                <button
                                    className="btn btn-danger w-sm waves-effect waves-light"
                                    type="button"
                                    onClick={() => history.goBack()}
                                >Back</button>
                                <button className="btn btn-primary w-sm waves-effect waves-light"
                                    type="button"
                                    onClick={() => formik.handleSubmit()}
                                >Submit</button>
                            </div>
                        </form>
                    </div>
                    <Loader isShow={loader} />
                </div>
            </div>
        </div>
    )
}
